import { closeReconciliationURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { getName } from 'utils/users/config';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import { ReconTaskVarianceThresholdCrossedNotification } from 'types/inbox-notifications/close/ReconciliationNotifications';
import { SegmentAtByDot } from 'types/utils';

type VarianceLevelKeys = SegmentAtByDot<
  ReconTaskVarianceThresholdCrossedNotification['type'],
  4
>;

export function VarianceNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ReconTaskVarianceThresholdCrossedNotification;
}) {
  const [actionType] = type;
  const { usersMap } = useUsersData();
  if (!item.task) {
    return <div>Reconciliation task not found</div>;
  }

  switch (actionType as VarianceLevelKeys) {
    case 'threshold_crossed':
      return (
        <GenericNotificationItem
          item={item}
          url={closeReconciliationURLs.taskInfo({
            taskId: item.task.core_snapshot.short_code,
          })}
          avatar={<UserAvatar userId={item.actor_id} />}
          title={`${getName(item.actor_id, usersMap)} crossed the variance threshold.`}
          description={
            <span>&quot;{item.task.core_snapshot.short_code}&quot;</span>
          }
        />
      );
    default:
      return (
        <div>
          Unknown reconciliation task variance notification type: {actionType}
        </div>
      );
  }
}
